(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[481],{

/***/ 11227:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof __webpack_require__.g&&__webpack_require__.g.global===__webpack_require__.g?__webpack_require__.g:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g, true&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map

/***/ }),

/***/ 88329:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var Phase;
(function(Phase) {
    Phase[Phase["PhaseI"] = 1] = "PhaseI";
    Phase[Phase["PhaseII"] = 2] = "PhaseII";
    Phase[Phase["PhaseIII"] = 3] = "PhaseIII";
    Phase[Phase["PhaseIV"] = 4] = "PhaseIV";
    Phase[Phase["PhaseV"] = 5] = "PhaseV";
})(Phase || (Phase = {}));
/* harmony default export */ __webpack_exports__["Z"] = (Phase);


/***/ }),

/***/ 23777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OfficialQuestionnairesPage_QuestionnaireTypesPanel; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./src/components/OfficialQuestionnairesPage/QuestionnaireTypesPanel/index.module.scss
var index_module = __webpack_require__(78730);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/hooks/useQuestionnaireTypes/index.tsx
var useQuestionnaireTypes = __webpack_require__(82060);
// EXTERNAL MODULE: ./src/_types/api/questionnaires/QuestionnaireKind.ts
var QuestionnaireKind = __webpack_require__(35247);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(95601);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/QuestionnaireDetailsPage/hooks/useCurrentQuestionnaire.ts
var useCurrentQuestionnaire = __webpack_require__(79747);
// EXTERNAL MODULE: ./src/elements/TooltipWrapper/TooltipWrapper.tsx + 11 modules
var TooltipWrapper = __webpack_require__(53046);
// EXTERNAL MODULE: ./node_modules/.pnpm/file-saver@2.0.5/node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(11227);
var FileSaver_min_default = /*#__PURE__*/__webpack_require__.n(FileSaver_min);
// EXTERNAL MODULE: ./src/hooks/useApi.ts
var useApi = __webpack_require__(7920);
// EXTERNAL MODULE: ./src/components/PublishedQuestionnairesPage/ExportCsvQuestionnaireModulesButton/exportCsvButton.module.scss
var exportCsvButton_module = __webpack_require__(77884);
var exportCsvButton_module_default = /*#__PURE__*/__webpack_require__.n(exportCsvButton_module);
// EXTERNAL MODULE: ./src/consts/paths/api/requests/requestsPath.ts
var requestsPath = __webpack_require__(21987);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./src/components/PublishedQuestionnairesPage/ExportCsvQuestionnaireModulesButton/index.tsx









function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var categoryIds = {
    core: 1,
    module: 2,
    standalone: 3
};
var getCategoryId = function(category) {
    if (!category) {
        return null;
    }
    return categoryIds[category];
};
var ExportCsvQuestionnairesModules = function(param) {
    var type = param.type;
    var api = (0,useApi/* default */.Z)();
    var questionnaire = (0,useCurrentQuestionnaire/* default */.Z)().questionnaire;
    var downloadCsv = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            var catId, result, data, blob;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.stopPropagation();
                        catId = getCategoryId(type);
                        _ctx.next = 4;
                        return api.get("".concat(requestsPath/* questionnaireLibraryPath */.Zf, "/questionnaire/report?categoryId=").concat(catId));
                    case 4:
                        result = _ctx.sent;
                        data = result.data;
                        blob = new Blob([
                            data
                        ], {
                            type: 'text/csv;charset=utf-8'
                        });
                        FileSaver_min_default().saveAs(blob, 'reports');
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function downloadCsv(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (exportCsvButton_module_default()).download,
        onClick: downloadCsv,
        tabIndex: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipWrapper/* default */.Z, {
            placement: "top",
            text: "Download as csv",
            tooltipId: "download".concat(questionnaire === null || questionnaire === void 0 ? void 0 : questionnaire.id),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "bi-download m-0 "
            })
        })
    }));
};
/* harmony default export */ var ExportCsvQuestionnaireModulesButton = (ExportCsvQuestionnairesModules);

;// CONCATENATED MODULE: ./src/components/OfficialQuestionnairesPage/QuestionnaireTypesPanel/index.tsx





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var QuestionnaireTypesPanel = function(param) {
    var onSelectedChange = param.onSelectedChange, selected = param.selected, _isForQuestionnaireModules = param.isForQuestionnaireModules, isForQuestionnaireModules = _isForQuestionnaireModules === void 0 ? false : _isForQuestionnaireModules;
    var questionnaireTypesByKind = (0,useQuestionnaireTypes/* default */.ZP)(isForQuestionnaireModules).questionnaireTypesByKind;
    var categories = [
        {
            label: 'All',
            type: null
        }, 
    ].concat(_toConsumableArray(questionnaireTypesByKind[QuestionnaireKind/* default.OFFICIAL */.Z.OFFICIAL].map(function(t) {
        return {
            label: t.labelPlural,
            type: t.type
        };
    })));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "Categories"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default()).listWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: categories.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: [
                                    (index_module_default()).icon,
                                    item.type ? (index_module_default())[item.type] : '',
                                    selected === item.type ? (index_module_default()).active : '', 
                                ].join(' '),
                                onClick: function() {
                                    return onSelectedChange(item.type);
                                },
                                children: [
                                    item.label,
                                    isForQuestionnaireModules && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExportCsvQuestionnaireModulesButton, {
                                        type: item.type
                                    })
                                ]
                            })
                        }, item.type);
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var OfficialQuestionnairesPage_QuestionnaireTypesPanel = (QuestionnaireTypesPanel);


/***/ }),

/***/ 53914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

function useQuestionnaireTypesPanel() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), selectedType = ref[0], setSelectedType = ref[1];
    return {
        selectedType: selectedType,
        setSelectedType: setSelectedType
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useQuestionnaireTypesPanel);


/***/ }),

/***/ 79747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export questionnaireIdAtom */
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var hooks_useApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7920);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88349);
/* harmony import */ var consts_sharedQueryKeys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37109);
/* harmony import */ var consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61680);
/* harmony import */ var hooks_useInvalidateQuestionnaires__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63359);
/* harmony import */ var _types_api_items_ItemType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75594);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7997);
/* harmony import */ var jotai_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68125);
/* harmony import */ var _useSelectedLanguage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24226);
/* harmony import */ var functions_api_tryGetApiError__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42711);
/* harmony import */ var hooks_useAlerts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96308);













function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var questionnaireIdAtom = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_8__/* .atomWithReset */ .rw)(null);
var useCurrentQuestionnaire = function() {
    var api = (0,hooks_useApi__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var ref = (0,hooks_useAlerts__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(), addSuccessAlert = ref.addSuccessAlert, addWarningAlert = ref.addWarningAlert;
    var invalidateQuestionnaires = (0,hooks_useInvalidateQuestionnaires__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var ref1 = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_9__/* .useAtom */ .KO)(questionnaireIdAtom), 2), questionnaireId = ref1[0], setQuestionnaireId = ref1[1];
    var resetQuestionnaireId = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_8__/* .useResetAtom */ .oC)(questionnaireIdAtom);
    var ref2 = (0,_useSelectedLanguage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), selectedLanguage = ref2.selectedLanguage, resetSelectedLanguage = ref2.resetSelectedLanguage;
    var ref3 = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        consts_sharedQueryKeys__WEBPACK_IMPORTED_MODULE_10__/* .questionnairesBaseQueryKey */ .iA,
        questionnaireId,
        selectedLanguage.code
    ], _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var result;
        return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get("".concat(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, "/").concat(questionnaireId, "/details/").concat(selectedLanguage.code));
                case 2:
                    result = _ctx.sent;
                    return _ctx.abrupt("return", result === null || result === void 0 ? void 0 : result.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: !!questionnaireId
    }), questionnaire = ref3.data, isQuestionnaireLoading = ref3.isLoading, isQuestionnaireError = ref3.isError, questionnaireError = ref3.error;
    var deleteQuestionnaire = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var result;
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return api.delete("".concat(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, "/").concat(questionnaireId));
                    case 2:
                        result = _ctx.sent;
                        _ctx.next = 5;
                        return invalidateQuestionnaires();
                    case 5:
                        _ctx.next = 7;
                        return next_router__WEBPACK_IMPORTED_MODULE_4__["default"].push('/');
                    case 7:
                        return _ctx.abrupt("return", result === null || result === void 0 ? void 0 : result.data);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteQuestionnaire() {
            return _ref.apply(this, arguments);
        };
    }();
    var publishQuestionnaire = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var result;
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return api.put("".concat(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, "/").concat(questionnaireId).concat(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__/* .publishQuestionnairePath */ .GF, "?url=").concat(window.location.href));
                    case 2:
                        result = _ctx.sent;
                        _ctx.next = 5;
                        return invalidateQuestionnaires();
                    case 5:
                        return _ctx.abrupt("return", result === null || result === void 0 ? void 0 : result.data);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function publishQuestionnaire() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteLanguageFromQuestionnaire = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return api.delete("".concat(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, "/").concat(questionnaireId, "/languages/").concat(selectedLanguage.code));
                    case 2:
                        _ctx.next = 4;
                        return invalidateQuestionnaires();
                    case 4:
                        resetSelectedLanguage();
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteLanguageFromQuestionnaire() {
            return _ref.apply(this, arguments);
        };
    }();
    var rejectQuestionnaire = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return api.put("".concat(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, "/").concat(questionnaireId).concat(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__/* .rejectQuestionnairePath */ .yd, "?url=").concat(window.location.href));
                    case 2:
                        _ctx.next = 4;
                        return invalidateQuestionnaires();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function rejectQuestionnaire() {
            return _ref.apply(this, arguments);
        };
    }();
    var addToVerifiedLanguages = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(code) {
            var apiError;
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return api.post("".concat(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, "/").concat(questionnaireId, "/languages"), {
                            code: code
                        });
                    case 3:
                        _ctx.next = 5;
                        return invalidateQuestionnaires();
                    case 5:
                        addSuccessAlert('Questionnaire updated!');
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        apiError = (0,functions_api_tryGetApiError__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ctx.t0);
                        if (apiError && apiError.error_description) {
                            addWarningAlert(apiError.error_description);
                        } else {
                            // Server error probably
                            addWarningAlert('Something went wrong, please try again.');
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function addToVerifiedLanguages(code) {
            return _ref.apply(this, arguments);
        };
    }();
    var addBulkTranslations = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return api.post("".concat(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, "/").concat(questionnaireId, "/translations/bulk-update"), data);
                    case 2:
                        _ctx.next = 4;
                        return invalidateQuestionnaires();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addBulkTranslations(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        questionnaire: questionnaire,
        setQuestionnaireId: setQuestionnaireId,
        isQuestionnaireLoading: isQuestionnaireLoading,
        isQuestionnaireError: isQuestionnaireError,
        questionnaireError: questionnaireError,
        deleteQuestionnaire: deleteQuestionnaire,
        publishQuestionnaire: publishQuestionnaire,
        numQuestions: questionnaire === null || questionnaire === void 0 ? void 0 : questionnaire.questionnaireItems.filter(function(qi) {
            return qi.item.type === _types_api_items_ItemType__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Question */ .Z.Question;
        }).length,
        resetCurrentQuestionnaire: resetQuestionnaireId,
        deleteLanguageFromQuestionnaire: deleteLanguageFromQuestionnaire,
        addToVerifiedLanguages: addToVerifiedLanguages,
        addBulkTranslations: addBulkTranslations,
        rejectQuestionnaire: rejectQuestionnaire
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCurrentQuestionnaire);


/***/ }),

/***/ 24226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export languageCodeAtom */
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);
/* harmony import */ var jotai_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68125);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var languageCodeAtom = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_0__/* .atomWithReset */ .rw)({
    code: 'en',
    name: 'English'
});
var useSelectedLanguage = function() {
    var ref = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .useAtom */ .KO)(languageCodeAtom), 2), selectedLanguage = ref[0], setSelectedLanguage = ref[1];
    var resetSelectedLanguage = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_0__/* .useResetAtom */ .oC)(languageCodeAtom);
    return {
        selectedLanguage: selectedLanguage,
        setSelectedLanguage: setSelectedLanguage,
        resetSelectedLanguage: resetSelectedLanguage
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSelectedLanguage);


/***/ }),

/***/ 11234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ PhaseTypes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2103);
/* harmony import */ var _types_Phase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88329);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PhaseTypes = [
    {
        label: 'Phase III completed',
        value: _types_Phase__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PhaseIII */ .Z.PhaseIII
    },
    {
        label: 'In phase IV',
        value: _types_Phase__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PhaseIV */ .Z.PhaseIV
    },
    {
        label: 'Phase IV completed',
        value: _types_Phase__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PhaseV */ .Z.PhaseV
    }, 
];
function FormPhaseSelect(props) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, props, {
        items: PhaseTypes,
        isHidingEmptyOptions: true
    })));
}
/* harmony default export */ __webpack_exports__["Z"] = (FormPhaseSelect);


/***/ }),

/***/ 616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlphabeticalList; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(44858);
// EXTERNAL MODULE: ./src/components/_questionnaires/Section/questionnaireLSection.module.scss
var questionnaireLSection_module = __webpack_require__(69175);
var questionnaireLSection_module_default = /*#__PURE__*/__webpack_require__.n(questionnaireLSection_module);
;// CONCATENATED MODULE: ./src/components/_questionnaires/Section/index.tsx



// eslint-disable-next-line no-empty-pattern
var QuestionnaireLSection = function(param) {
    var letter = param.letter, children = param.children;
    var label = letter.toLocaleUpperCase();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (questionnaireLSection_module_default()).letter,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var Section = (QuestionnaireLSection);

// EXTERNAL MODULE: ./src/components/_questionnaires/List/index.tsx + 1 modules
var List = __webpack_require__(94796);
// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/index.js + 235 modules
var es = __webpack_require__(62058);
;// CONCATENATED MODULE: ./src/components/_questionnaires/AlphabeticalList/index.tsx





var generateGroups = (0,es/* pipe */.zGw)((0,es/* groupBy */.vMG)(function(item) {
    return item.name.trim()[0].toUpperCase();
}), es/* toPairs */.Zpf, (0,es/* sortBy */.MRu)(function(item) {
    return item[0];
}));
var AlphabeticalQuestionnaireList = function(param) {
    var questionnaires = param.questionnaires, colSm = param.colSm, _isPDFPage = param.isPDFPage, isPDFPage = _isPDFPage === void 0 ? false : _isPDFPage;
    var ref = (0,react.useState)(), groupedQuestionnaires = ref[0], setGroupedQuestionnaires = ref[1];
    (0,react.useEffect)(function() {
        setGroupedQuestionnaires(generateGroups(questionnaires));
    }, [
        questionnaires
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: groupedQuestionnaires && groupedQuestionnaires.map(function(item) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Section, {
                letter: item[0],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    questionnaires: item[1],
                    colSm: colSm,
                    isPDFPage: isPDFPage
                })
            }, item[0]);
        })
    }));
};
/* harmony default export */ var AlphabeticalList = (AlphabeticalQuestionnaireList);


/***/ }),

/***/ 94796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ List; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(44858);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(42359);
// EXTERNAL MODULE: ./src/_types/api/questionnaires/QuestionnaireState.ts
var QuestionnaireState = __webpack_require__(96439);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/link.js
var next_link = __webpack_require__(70462);
// EXTERNAL MODULE: ./src/components/_questionnaires/ListItem/questionnaireListItem.module.scss
var questionnaireListItem_module = __webpack_require__(77024);
var questionnaireListItem_module_default = /*#__PURE__*/__webpack_require__.n(questionnaireListItem_module);
// EXTERNAL MODULE: ./src/components/_questionnaires/QuestionnaireIcon/index.tsx
var QuestionnaireIcon = __webpack_require__(10840);
;// CONCATENATED MODULE: ./src/components/_questionnaires/ListItem/index.tsx





var QuestionnaireListItem = function(param) {
    var name = param.name, type = param.type, state = param.state, numQuestions = param.numQuestions, code = param.code, id = param.id, isCustom = param.isCustom, isPDFPage = param.isPDFPage;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: isPDFPage ? "pdf-questionnaire?id=".concat(id) : "questionnaires?id=".concat(id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "".concat((questionnaireListItem_module_default()).link, " d-flex"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionnaireIcon/* default */.Z, {
                    state: state,
                    type: type,
                    code: code,
                    isCustom: isCustom
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: (questionnaireListItem_module_default()).name,
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (questionnaireListItem_module_default()).type,
                            children: type
                        }),
                        state === QuestionnaireState/* default.WAITING_FOR_APPROVAL */.Z.WAITING_FOR_APPROVAL ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (questionnaireListItem_module_default()).waitingApproval,
                            children: "Waiting for approval"
                        }) : numQuestions && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (questionnaireListItem_module_default()).questionsNum,
                            children: " (".concat(numQuestions, " ").concat(numQuestions === 1 ? 'question' : 'questions', " )")
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var ListItem = (QuestionnaireListItem);

// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/index.js + 235 modules
var es = __webpack_require__(62058);
;// CONCATENATED MODULE: ./src/components/_questionnaires/List/index.tsx




var QuestionnaireList = function(param) {
    var questionnaires = param.questionnaires, _colSm = param.colSm, colSm = _colSm === void 0 ? 4 : _colSm, _isPDFPage = param.isPDFPage, isPDFPage = _isPDFPage === void 0 ? false : _isPDFPage;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: questionnaires && (0,es/* sortBy */.MRu)(function(item) {
                return item.name;
            }, questionnaires).map(function(q) {
                var ref, ref1, ref2;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    sm: colSm,
                    className: "my-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                        id: q.id,
                        name: q.name,
                        state: (ref = q) === null || ref === void 0 ? void 0 : ref.state,
                        type: q.type.toString().toLowerCase(),
                        code: q.code,
                        numQuestions: (ref1 = q) === null || ref1 === void 0 ? void 0 : ref1.numQuestions,
                        isCustom: (ref2 = q) === null || ref2 === void 0 ? void 0 : ref2.isCustom,
                        isPDFPage: isPDFPage
                    })
                }, q.id));
            })
        })
    }));
};
/* harmony default export */ var List = (QuestionnaireList);


/***/ }),

/***/ 12535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var components_questionnaires_ListItem_questionnaireListItem_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77024);
/* harmony import */ var components_questionnaires_ListItem_questionnaireListItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(components_questionnaires_ListItem_questionnaireListItem_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _questionnaireListItemCreate_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62574);
/* harmony import */ var _questionnaireListItemCreate_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_questionnaireListItemCreate_module_scss__WEBPACK_IMPORTED_MODULE_1__);

/* eslint-disable @next/next/link-passhref */ 

var QuestionnaireListItemCreate = function(param) {
    var onClick = param.onClick, text = param.text;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: "".concat((_questionnaireListItemCreate_module_scss__WEBPACK_IMPORTED_MODULE_1___default().button), " d-flex"),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " ".concat((_questionnaireListItemCreate_module_scss__WEBPACK_IMPORTED_MODULE_1___default().create), " ").concat((components_questionnaires_ListItem_questionnaireListItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().background), " d-flex justify-content-center align-items-center")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_questionnaireListItemCreate_module_scss__WEBPACK_IMPORTED_MODULE_1___default().text),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "+"
                    }),
                    text
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuestionnaireListItemCreate);


/***/ }),

/***/ 10840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var _questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12706);
/* harmony import */ var _questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _types_api_questionnaires_QuestionnaireState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96439);



var QuestionnaireIcon = function(param) {
    var state1 = param.state, type1 = param.type, isCustom = param.isCustom, code1 = param.code, number = param.number;
    var getBgClass = function(state, type) {
        if (type === null || isCustom) {
            if (state === _types_api_questionnaires_QuestionnaireState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].WAITING_FOR_APPROVAL */ .Z.WAITING_FOR_APPROVAL || state === _types_api_questionnaires_QuestionnaireState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DRAFT */ .Z.DRAFT) {
                return (_questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().draft);
            }
            return (_questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().previous);
        }
        return (_questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[type];
    };
    var getFontClass = function(code) {
        if (code && code.length > 4) {
            return (_questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().smallCode);
        }
        return (_questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().code);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(getBgClass(state1, type1), " ").concat(number !== undefined ? (_questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().backgroundBig) : (_questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().background), " d-flex justify-content-center align-items-center"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: getFontClass(code1),
                children: code1 ? code1 : ''
            }),
            number !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_questionnaireIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().number),
                children: number
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuestionnaireIcon);


/***/ }),

/***/ 78730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuestionnaireTypesPanel_wrapper__dRC4x","listWrapper":"QuestionnaireTypesPanel_listWrapper__TDZdT","active":"QuestionnaireTypesPanel_active__wbpOq","icon":"QuestionnaireTypesPanel_icon___4F5b","core":"QuestionnaireTypesPanel_core__umca4","module":"QuestionnaireTypesPanel_module__5QaYi","standalone":"QuestionnaireTypesPanel_standalone__6Gl8S","previous":"QuestionnaireTypesPanel_previous__IW76H","cat":"QuestionnaireTypesPanel_cat__1YfYW","catshort":"QuestionnaireTypesPanel_catshort__NbnYE","shortform":"QuestionnaireTypesPanel_shortform__SyWft"};

/***/ }),

/***/ 77884:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"download":"exportCsvButton_download__vkzwS"};

/***/ }),

/***/ 77024:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"background":"questionnaireListItem_background__5k0hs","name":"questionnaireListItem_name__xWMaG","type":"questionnaireListItem_type__6l6BS","questionsNum":"questionnaireListItem_questionsNum__jucar","waitingApproval":"questionnaireListItem_waitingApproval__XYINo","link":"questionnaireListItem_link__5einU"};

/***/ }),

/***/ 62574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"create":"questionnaireListItemCreate_create__ubgRn","text":"questionnaireListItemCreate_text__89yrR","button":"questionnaireListItemCreate_button__apYP3"};

/***/ }),

/***/ 12706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"background":"questionnaireIcon_background__dY_qN","backgroundBig":"questionnaireIcon_backgroundBig__7tayw","number":"questionnaireIcon_number__WQK5_","core":"questionnaireIcon_core__RU_EH","module":"questionnaireIcon_module__UNBBY","standalone":"questionnaireIcon_standalone__G9UOq","previous":"questionnaireIcon_previous__tHh3c","cat":"questionnaireIcon_cat__vHuUW","catshort":"questionnaireIcon_catshort__75rpU","itemlist":"questionnaireIcon_itemlist__9yiYb","draft":"questionnaireIcon_draft__Sj_nv","shortform":"questionnaireIcon_shortform__a01G_","smallCode":"questionnaireIcon_smallCode__VI05E","code":"questionnaireIcon_code__9G_bH"};

/***/ }),

/***/ 69175:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"letter":"questionnaireLSection_letter__qioCl"};

/***/ })

}]);